import { AppPasswordTextField, AppTextField, AppTextFieldProps } from 'components/core/AppTextField/AppTextField';
import { AlluraFormikErrorMessage } from 'components/formik/core/AlluraErrorMessage/AlluraFormikErrorMessage';
import { useField } from 'formik';

interface Props {
  name: string;

  isPasswordField?: boolean;
}

type FormikAppTextFieldProps = Props & Omit<AppTextFieldProps, 'value' | 'onChange' | 'name'>;

export const FormikAppTextField = ({
  name,
  isPasswordField,
  title,
  description,
  onBlur = () => null,
  ...rest
}: FormikAppTextFieldProps) => {
  const [field, , helpers] = useField(name);

  const onChange = (e: any) => {
    helpers.setValue(e.target.value);
  };

  return (
    <>
      {isPasswordField ? (
        <AppPasswordTextField
          name={field.name}
          value={field.value}
          onChange={onChange}
          autoComplete='off'
          onBlur={e => {
            field.onBlur(e);
            onBlur && onBlur(e);
          }}
          title={title}
          description={description}
          {...rest}
        />
      ) : (
        <AppTextField
          name={field.name}
          value={field.value}
          onChange={onChange}
          onBlur={e => {
            field.onBlur(e);
            onBlur && onBlur(e);
          }}
          title={title}
          description={description}
          {...rest}
        />
      )}
      <AlluraFormikErrorMessage fieldName={name} />
    </>
  );
};
